import themeCreator from '@Themes/themeCreator';

const customTheme = themeCreator();

const useChatBotStyles = () => ({
  paperProps: (dialogState) => ({
    boxShadow: `0px ${customTheme.spacing(0.5)} ${customTheme.spacing(1)} rgba(0, 0, 0, 0.2)`, // Equivalent to 4px 8px
    pointerEvents: 'auto',
    margin: 0,
    position: 'fixed',
    left: dialogState.isFullScreen ? 0 : dialogState.position.x,
    top: dialogState.isFullScreen ? 0 : dialogState.position.y,
    display: 'flex',
    flexDirection: 'column',
    height: dialogState.size.height,
    width: dialogState.size.width,
    minHeight: 550,
    minWidth: 450,
    maxWidth: dialogState.isFullScreen ? null : 2000,
    maxHeight: dialogState.isFullScreen ? null : 1000,
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      width: customTheme.spacing(0.5), // Equivalent to 4px
      height: customTheme.spacing(0.0625), // Equivalent to 0.5px
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent', // Initially transparent
      borderRadius: customTheme.spacing(0.5), // Equivalent to 4px
      transition: 'background-color 0.3s', // Smooth transition effect
    },
    '&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
      backgroundColor: 'transparent', // Track remains transparent
    },
    '&:hover::-webkit-scrollbar-thumb, & *:hover::-webkit-scrollbar-thumb': {
      backgroundColor: '#9e9e9e', // Medium grey on hover
    },
  }),
  popupButton: {
    marginLeft: 0,
    marginRight: customTheme.spacing(1), // Equivalent to 8px
    fontSize: customTheme.typography.pxToRem(60), // Using pxToRem for font sizing
    borderRadius: '50%',
    padding: 0,
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
    alignItems: 'flex-end',
    position: 'fixed',
    bottom: "5.5%",
    right: "1%",
    zIndex: 1000, // Ensure it is above other elements
    boxShadow: `0px ${customTheme.spacing(0.5)} ${customTheme.spacing(1)} rgba(0, 0, 0, 0.2)`, // Equivalent to 4px 8px
  },
  popupContent: {
    padding: 0,
    flexGrow: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
    position: 'relative',
  },
  popupHeader: (isDragging) => ({
    padding: `${customTheme.spacing(0.75)} ${customTheme.spacing(1.375)}`,
    position: 'relative',
    cursor: isDragging ? 'grabbing' : 'grab',
    zIndex: 1000, // Ensure header has lower z-index than top resize handles
  }),
  popupHeaderIcons: {
    display: 'flex',
    alignItems: 'center',
  },
  resizeHandle: (direction) => {
    const baseStyles = {
      position: 'absolute',
      backgroundColor: 'transparent',
      zIndex: 1003, // Increased from 1001
    };

    const directionStyles = {
      'top': {
        ...baseStyles,
        top: 0,
        left: 0, // Changed from customTheme.spacing(1) to 0
        right: 0, // Changed from customTheme.spacing(1) to 0
        height: customTheme.spacing(1), // Reduced from spacing(2)
        cursor: 'n-resize',
        zIndex: 1004, // Increased from 1002
      },
      'bottom': {
        ...baseStyles,
        bottom: 0,
        left: customTheme.spacing(1),
        right: customTheme.spacing(1),
        height: customTheme.spacing(0.5),
        cursor: 's-resize',
      },
      'left': {
        ...baseStyles,
        left: 0,
        top: customTheme.spacing(1),
        bottom: customTheme.spacing(1),
        width: customTheme.spacing(0.5),
        cursor: 'w-resize',
      },
      'right': {
        ...baseStyles,
        right: 0,
        top: customTheme.spacing(1),
        bottom: customTheme.spacing(1),
        width: customTheme.spacing(0.5),
        cursor: 'e-resize',
      },
      'top-left': {
        ...baseStyles,
        top: 0,
        left: 0,
        width: customTheme.spacing(1.5),
        height: customTheme.spacing(1.5),
        cursor: 'nw-resize',
        zIndex: 1004, // Increased from 1002
      },
      'top-right': {
        ...baseStyles,
        top: 0,
        right: 0,
        width: customTheme.spacing(1.5),
        height: customTheme.spacing(1.5),
        cursor: 'ne-resize',
        zIndex: 1004, // Increased from 1002
      },
      'bottom-left': {
        ...baseStyles,
        bottom: 0,
        left: 0,
        width: customTheme.spacing(1),
        height: customTheme.spacing(1),
        cursor: 'sw-resize',
      },
      'bottom-right': {
        ...baseStyles,
        bottom: 0,
        right: 0,
        width: customTheme.spacing(1),
        height: customTheme.spacing(1),
        cursor: 'se-resize',
      },
    };

    return directionStyles[direction];
  },
  resetButton: {
    cursor: 'pointer',
    position: 'absolute',
    right: customTheme.spacing(7.5), // Equivalent to 60px
    top: customTheme.spacing(1.75), // Equivalent to 14px
    color: 'grey',
  },
  fullScreenButton: {
    fontSize: customTheme.typography.pxToRem(19), // Using pxToRem for font sizing
    cursor: 'pointer',
    position: 'absolute',
    right: customTheme.spacing(4.5), // Equivalent to 36px
    top: customTheme.spacing(2), // Equivalent to 16px
    color: 'grey',
  },
  closeButton: {
    cursor: 'pointer',
    position: 'absolute',
    right: customTheme.spacing(1.25), // Equivalent to 10px
    top: customTheme.spacing(1.75), // Equivalent to 14px
    color: 'grey',
  },
clearContextButton: (isLoading = false) => ({
  cursor: isLoading ? 'not-allowed' : 'pointer',
  position: 'absolute',
  left: customTheme.spacing(39),
  top: customTheme.spacing(1.75),
  color: isLoading ? '#e0c700' : 'grey', // Brighter yellow
  opacity: isLoading ? 0.8 : 1,
  transform: isLoading ? 'scale(1.2)' : 'scale(1)', // Larger scale
  transition: 'all 0.8s ease-in-out', // Longer transition
  animation: isLoading ? 'contextPulse 1s infinite' : 'none',
  '&:hover': {
    color: isLoading ? '#e0c700' : '#e0c700',
    transform: isLoading ? 'scale(1.2) translateY(-1px)' : 'scale(1.15) translateY(-1px)', // Add vertical movement
    filter: 'brightness(1.1)', // Add brightness effect
  },
  '@keyframes contextPulse': {
    '0%': {
      opacity: 0.6,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 1,
      transform: 'scale(1.2)', // Bigger pulse
    },
    '100%': {
      opacity: 0.6,
      transform: 'scale(1)',
    },
  },
}),

clearChatButton: (isLoading = false) => ({
  cursor: isLoading ? 'not-allowed' : 'pointer',
  position: 'absolute',
  left: customTheme.spacing(35),
  top: customTheme.spacing(1.75),
  color: isLoading ? '#f44336' : 'grey', // Brighter red
  opacity: isLoading ? 0.8 : 1,
  transform: isLoading ? 'scale(1.2)' : 'scale(1)', // Larger scale
  transition: 'all 0.8s ease-in-out', // Longer transition
  animation: isLoading ? 'chatPulse 1s infinite' : 'none',
  '&:hover': {
    color: isLoading ? '#f44336' : '#f44336',
    transform: isLoading ? 'scale(1.2) translateY(-1px)' : 'scale(1.15) translateY(-1px)', // Add vertical movement
    filter: 'brightness(1.1)', // Add brightness effect
  },
  '@keyframes chatPulse': {
    '0%': {
      opacity: 0.6,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 1,
      transform: 'scale(1.2)', // Bigger pulse
    },
    '100%': {
      opacity: 0.6,
      transform: 'scale(1)',
    },
  },
}),
  resizeButtonIcon:{
    fontSize: customTheme.typography.pxToRem(12), // Set icon size
    color: 'grey', // Set icon color
  },

  theme: customTheme,
});

export default useChatBotStyles;
